export class StringsHelper {
    public static generateRandomString(length: number) {
        return Math.random()
            .toString(36)
            .substring(2, length + 2);
    }
    public static concatWithSeparator(separator: string, ...values: Array<string | null | undefined>): string {
        return [...values].filter((value) => value).join(separator);
    }

    public static generateUUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    public static stripCorruptChars(str: string) {
        // eslint-disable-next-line no-control-regex
        const corruptCharacters = /[\x00-\x08\x0B\x0C\x0E-\x1F]/g;
        return str.replace(corruptCharacters, "");
    }
}
